<template>
  <!-- MD-4 (MD-K4): rapor filtreleri. Masaüstünde sayfanın filtre satırı (slot) aynen yerinde.
       Dar ekranda tek satır: Dönem çipi + «Filtre (n)»; alanlar (tarihler, Şube, Durum…) alttan
       açılan panelde. Çipte seçim → sayfanın filtre fonksiyonu (@uygula) hemen çağrılır; panelde
       sayfanın kendi Filtrele düğmesine basılınca panel kapanır. -->
  <slot v-if="!ekran.dar" />
  <div v-else class="flex items-center gap-2 mb-3">
    <DonemSecici v-if="tarihli" class="flex-1" :baslangic="baslangic" :bitis="bitis"
      @update:baslangic="$emit('update:baslangic', $event)" @update:bitis="$emit('update:bitis', $event)"
      @degisti="$emit('uygula')" />
    <!-- Tarihsiz sayfada çipin yerine sayfanın kendi denetimi (Studio: görünüm seçici) konabilir. -->
    <slot v-else name="sol"><span class="flex-1"></span></slot>
    <Button v-if="panelli" type="button" severity="secondary" outlined icon="pi pi-sliders-h"
      :label="'Filtre' + (degisenSayisi ? ' (' + degisenSayisi + ')' : '')" class="shrink-0" @click="acik = true" />
  </div>
  <Drawer v-if="ekran.dar && panelli" v-model:visible="acik" position="bottom" header="Filtreler" class="!h-auto max-h-[85vh]">
    <div class="pt-2" @click.capture="icTikla">
      <slot />
    </div>
  </Drawer>
</template>

<script>
import { darEkranDurum } from "@/services/darEkran";
import DonemSecici from "./DonemSecici.vue";

export default {
  name: "FiltrePaneli",
  components: { DonemSecici },
  props: {
    baslangic: { type: [Date, String], default: null },
    bitis: { type: [Date, String], default: null },
    // Tarih dışındaki filtre alanlarının değerleri (ör. [selectedSube, Durum]); ilk değerden
    // farklı olanlar «Filtre (n)»de sayılır.
    degerler: { type: Array, default: () => [] },
    // Sayfada tarih yoksa (Risk, Yaşlandırma…) çip çizilmez.
    tarihli: { type: Boolean, default: true },
    // Tarih dışında alan yoksa (Kasa Panosu) dar ekranda yalnız Dönem çipi, «Filtre» düğmesi yok.
    panelli: { type: Boolean, default: true },
  },
  emits: ["update:baslangic", "update:bitis", "uygula"],
  data() {
    return {
      ekran: darEkranDurum,
      acik: false,
      ilk: JSON.stringify(this.degerler),
    };
  },
  computed: {
    degisenSayisi() {
      let ilk;
      try {
        ilk = JSON.parse(this.ilk);
      } catch (e) {
        return 0;
      }
      return this.degerler.filter((v, i) => JSON.stringify(v) !== JSON.stringify(ilk[i])).length;
    },
  },
  methods: {
    // Panelde sayfanın eylem düğmesine (Filtrele, Temizle…) basılınca panel kapanır; tarih
    // seçicinin ikon düğmesi ve seçim kutuları kapatmaz.
    icTikla(e) {
      const d = e.target.closest(".p-button");
      if (!d || d.closest(".p-datepicker, .p-select, .p-inputgroup, .p-selectbutton, .p-togglebutton, .p-multiselect")) return;
      setTimeout(() => {
        this.acik = false;
      }, 0);
    },
  },
};
</script>
